<template>
  <div class="search">
    <div class="searchbody container">
      <div class="searchbodytitle">
        <h1 class="title_font">{{title}}</h1>
        <v-line></v-line>
      </div>
      <div class="searchinput">
        <input
          type="text"
          :placeholder="$t('home.search_our_store')"
          v-model="search"
          autofocus
          name="q"
          autocomplete
          @keyup.enter="searchcommondity()"
        />
        <span class="iconfont" @click="searchcommondity">&#xe618;</span>
      </div>
      <div class="row searchresult">
        <div class="col-md-4 col-sm-6" v-for="(item,index) in searchres.data" :key="index">
          <v-commodityitem :product="item"></v-commodityitem>
        </div>
      </div>
      <div class="paging" v-if="searchres.last_page>1" style="margin-top:30px;">
        <el-pagination
          :page-size="searchres.per_page"
          :current-page="searchres.current_page"
          layout="prev, pager, next"
          :total="searchres.total"
          @current-change="page"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import vCommodityitem from "../common/commodityitem";
export default {
  props: ["products", "q", "pixel"],
  data() {
    return {
      num: 1,
      to: 100,
      title: "Search",
      search: "",
      searchres: ""
    };
  },
  methods: {
    showleftmenu() {
      this.$(".search").animate({ left: "300px" }, 300);
      this.$("html,body").css({ overflow: "hidden" });
    },
    hiddenleftmenu() {
      this.$refs.son.showmenu = true;
      this.$(".search").animate({ left: "0" }, 300);
      this.$("html,body").css({ overflow: "visible" });
      this.$(".pricelist").css("display", "none");
    },
    searchcommondity() {
      if (window.fbq) {
        console.log("Search");
        window.fbq("track", "Search", { search_string: this.search });
      }
      window.open("search?q=" + encodeURIComponent(this.search), "_self");
    },
    page(e) {
      window.open(
        this.searchres.path + "?page=" + e + "&q=" + encodeURIComponent(this.search),
        "_self"
      );
    }
  },
  beforeMount() {
    // 这个products是搜索结果
    this.searchres = JSON.parse(this.products);
    console.log(this.searchres);
    this.search = this.q;
    if (this.q == "") {
      this.title = this.$t('home.search_our_store');
    } else if (this.q != "" && this.searchres.data.length) {
      this.title = `${this.$t('search.your_search_for')}"${this.q}" ${this.$t('search.revealed_the_following')}`;
    } else {
      this.title = `${this.$t('search.your_search_for')}"${this.q}" ${this.$t('search.not_results')}`;
    }
  },
  components: {
    vCommodityitem
  }
};
</script>
<style scoped lang='scss'>
.search {
  position: relative;
  .searchbody {
    text-align: center;

    .searchbodytitle {
      h1 {
        margin-top: 16px;
        font-size: 26px;
      }
    }

    .searchinput {
      width: 300px;
      margin: 50px auto 0;
      display: flex;

      input {
        width: 10px;
        border: none;
        height: 45px;
        flex: 1;
        padding: 8px 10px;
        background: #f6f6f6;
        font-size: 18px;
      }

      span {
        width: 56px;
        height: 45px;
        line-height: 45px;
        background: #c90d0d;
        color: white;
        border: none;
        font-size: 12px;
        cursor: pointer;
      }
    }

    .searchresult {
      margin-top: 90px;
    }
  }
}

@media screen and (max-width: 370px) {
  .searchbody {
    .searchinput {
      width: 90% !important;
    }
  }
}
</style>